export enum Cookies {
  UCX_EXPIRY = 'ucx-token-exp',
  SESSION_IDENTIFIER = 'session-identifier',
  LOGGED_IN = 'loggedIn',
  PROVINCE = 'province',
  ADOBE_AU = 'aam_uuid',
  ADOBE_MC = '_sdsat_MCID',
  ADOBE_HB = 'aam_dpid942',
  LANGUAGE = 'language',
}

export function getCookie(cname: Cookies) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieList = decodedCookie.split(';');
  for (let cookie of cookieList) {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
}
